export const unitMap: GenericObject = {
	nomeunidade: "name",
};
